<div class="h-[calc(100vh-48px)] overflow-y-auto hide-scrollbar">
  <tui-loader [overlay]="true" [showLoader]="!!(loading$ | async)">
    <table
      *ngIf="data$ | async as data"
      tuiTable
      class="journal-table w-full"
      [columns]="columns"
    >
      <tbody *tuiLet="data as sortedData" tuiTbody [data]="sortedData">
        <tr
          (dblclick)="openSpecification(item.id)"
          *ngFor="let item of sortedData"
          tuiTr
          class="cursor-pointer"
        >
          @for (header of header; track 'value') {
            <td *tuiCell="header.value" tuiTd>
              {{ item[header.value] }}
            </td>
          }
        </tr>
      </tbody>
    </table>
  </tui-loader>
</div>
